"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/TemplatePicker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);











const TemplatePickerRow = _react.memo.call(void 0, ({ row, index, selected, loading, onPick, onHover }) => {
  const pick = _react.useCallback.call(void 0, (e) => { e.preventDefault(); onPick(row.template) }, [onPick, row.template])
  const hover = _react.useCallback.call(void 0, () => onHover(index), [onHover, index])
  return (
    _react2.default.createElement('div', {
      id: `template-option-${row.template.TemplateKey}`,
      role: "option",
      'aria-selected': selected,
      'aria-busy': loading ? true : undefined,
      className: _classBuilder2.default.call(void 0, 'template-picker--row', selected && 'template-picker--row--selected', loading === 'slow' && 'template-picker--row--loading'),
      onMouseDown: pick,
      onMouseEnter: hover, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

      , _react2.default.createElement('div', { className: "template-picker--row-top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        , _react2.default.createElement('span', { className: "template-picker--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  row.template.Name )
        , _react2.default.createElement('span', { className: "template-picker--scope", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}},  row.scopeLabel )
        , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'template-picker--fill', row.missing === 0 && 'template-picker--fill--ready'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
          ,  row.missing === 0 ? 'ready' : `${row.missing} to fill` 
        )
      )
      , _react2.default.createElement('div', { className: "template-picker--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        ,  row.preview.map((segment, i) => segment.blank
          ? _react2.default.createElement('mark', { key: i, className: "template-picker--blank", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  segment.text )
          : _react2.default.createElement(_react2.default.Fragment, { key: i, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}},  segment.text ),
        )
      )
    )
  )
})
TemplatePickerRow.displayName = 'TemplatePickerRow'















// Acting on mousedown would move focus off the composer field; keep it there.
const keepFocus = (e) => e.preventDefault()

/* The templates listbox: name, scope (Mine / a team / Org) and "ready" or
 * "N to fill" for this chat. Arrow keys, Enter and Esc are handled by
 * whatever owns focus (the composer field or the picker's search box). */
const TemplatePicker = ({ rows, status, selectedIndex, query, onPick, onHover, className, loading, onManage }) => (
  _react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('div', {
    className: _classBuilder2.default.call(void 0, 'template-picker', className),
    role: "listbox",
    'aria-label': "Templates",
    'aria-activedescendant': rows[selectedIndex] ? `template-option-${rows[selectedIndex].template.TemplateKey}` : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}

    ,  status === 'error' && rows.length === 0 && _react2.default.createElement('div', { className: "template-picker--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, "Couldn't load templates."  ) 
    ,  status === 'loading' && _react2.default.createElement('div', { className: "template-picker--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}, "Loading templates…" ) 
    ,  status === 'ready' && rows.length === 0 && (
      _react2.default.createElement('div', { className: "template-picker--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        ,  query
          ? `No templates match "${query.replace(/^\//, '')}".`
          : onManage ? 'No templates yet. Create one in Manage templates.' : 'No templates yet.' 
      )
    )
    ,  rows.map((row, index) => (
      _react2.default.createElement(TemplatePickerRow, {
        key: row.template.TemplateKey,
        row: row,
        index: index,
        selected: index === selectedIndex,
        loading: _optionalChain([loading, 'optionalAccess', _ => _.key]) === row.template.TemplateKey ? (loading.slow ? 'slow' : 'pending') : false,
        onPick: onPick,
        onHover: onHover, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
      )
    ))
  )
  ,  onManage && (
    _react2.default.createElement('button', { type: "button", className: "template-picker--manage", onMouseDown: keepFocus, onClick: onManage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "Manage templates…"

    )
  )
  )
)

exports. default = _react.memo.call(void 0, TemplatePicker)

/* Arrow keys and Enter over the rows; returns true when it handled the key.
 * Enter is always taken while the picker is open, even with no row to pick
 * (loading, an error, no match), so it never sends the "/query" draft. */
 const handlePickerKey = (
  e,
  rows,
  selectedIndex,
  setSelectedIndex,
  onPick,
  onClose,
) => {
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault()
    if (rows.length) setSelectedIndex((selectedIndex + (e.key === 'ArrowDown' ? 1 : rows.length - 1)) % rows.length)
    return true
  }
  if (e.key === 'Enter') {
    e.preventDefault()
    const row = rows[selectedIndex]
    if (row) onPick(row.template)
    return true
  }
  if (e.key === 'Escape') {
    e.preventDefault()
    onClose()
    return true
  }
  return false
}; exports.handlePickerKey = handlePickerKey
